










import { defineComponent, PropType } from '@vue/composition-api'
import { sendInvoicePdf } from '~/api/Agency/agency.api'
import { Invoice } from '~/api/Agency/agency.interface'
import IconButton from '~/components/IconButton.vue'

export default defineComponent({
  components: { IconButton },
  props: {
    item: { type: Object as PropType<Invoice>, required: true },
  },
  data() {
    return {
      loading: false,
    }
  },
  methods: {
    async onClick() {
      try {
        this.loading = true
        await sendInvoicePdf(this.item.uuid)
      } finally {
        this.loading = false
      }
    },
  },
})
